import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { postData, imageBaseUrl } from "../../Networking/Api";

import CustomSelect from "../CustomSelect";
import CustomSelectHealth from "../CustomSelectHealth";
import ClinicBookingHeader from "./ClinicBookingHeader";
import ClinicBookingFooter from "./ClinicBookingFooter";
import Swal from "sweetalert2";
import { encrypt } from "../CryptoUtil";
import Loader2 from "../Loader2";

function CliniBookAnAppoinment() {
    let { clinicName, city: cityStreetParam, appointmentType: urlAppointmentType } = useParams();
    let urlCity, urlStreet;

    // Split the cityStreetParam to get city and street
    if (cityStreetParam && cityStreetParam.includes("-")) {
        [urlCity, urlStreet] = cityStreetParam.split("-");
    }

    const [selectedOptions, setSelectedOptions] = useState({
        insuranceType: "",
        appointmentType: "",
        chooseCarrierAndPlan: "",
    });
    const [selectedOptionsId, setSelectedOptionsId] = useState({
        insuranceTypeId: "",
        appointmentTypeId: "",
        chooseCarrierAndPlanId: "",
    });
    const [options, setOptions] = useState({
        insuranceType: [],
        appointmentType: [],
    });
    const [insurancePlans, setInsurancePlans] = useState([]);
    const [locations, setLocations] = useState([]);
    const [clinicId, setClinicId] = useState("");
    const [loading, setLoading] = useState(true);
    const [streetid, setStreetId] = useState("");
    const [clinicNameData, setClinicNameData] = useState("");
    const [logoImg, setLogoImg] = useState("");
    const [cityname, setCityName] = useState(urlCity || "");
    const [streetName, setStreetname] = useState(urlStreet || "");
    const [hasNoInsurance, setHasNoInsurance] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchClinicData = async () => {
            try {
                setLoading(true);
                const payload = {
                    clinicName: clinicName,
                    // Only pass city-street combination, not appointment type
                    cityStreetName:
                        urlCity && urlStreet ? `${urlCity}-${urlStreet}` : undefined,
                    nohearder: 1,
                };
                const response = await postData("clinics/getClinicInfo", payload);

                if (response.code === 0) {
                    setLoading(false);
                    Swal.fire("Clinic location not found").then(() => {
                        navigate("/patientLanding");
                    });
                } else if (response.code === 1) {
                    const fetchedClinicId = response.clinics.id;
                    setClinicId(fetchedClinicId);
                    setClinicNameData(response.clinics.name);
                    setLogoImg(response.clinics.logo_image);
                    setStreetId(response.clinic_locations_data.id);
                    if (!urlCity) setCityName(response.clinic_locations_data.city);
                    if (!urlStreet) setStreetname(response.clinic_locations_data.street);

                    fetchLocations(fetchedClinicId);
                    fetchOptions(fetchedClinicId);
                }
            } catch (error) {
                setLoading(false);
                console.error("Error fetching initial clinic data:", error);
            }
        };

        fetchClinicData();
    }, [clinicName, urlCity, urlStreet, navigate]);

    const fetchLocations = async (clinicId) => {
        try {
            const payload = {
                modelName: "clinic_locations",
                whereCondition: {
                    clinic_id: clinicId,
                    is_deleted: 0,
                    is_active: 1,
                },
            };
            const response = await postData("masters/getMasterList", payload);
            if (response.code === 1) {
                setLocations(response.data);
            } else {
                setLocations([]);
            }
        } catch (error) {
            console.error("Error fetching clinic locations:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchOptions = async (clinicId) => {
        try {
            setLoading(true);

            // Fetch appointment types
            const appointmentResponse = await postData("patients/getAppoinmentTypeDataNew", {
                type: "clinicServices",
                id: clinicId,
            });

            // Fetch insurance carriers with plans
            const insuranceResponse = await postData("masters/getMasterList", {
                modelName: "clinic_insurances",
                whereCondition: {
                    clinic_id: clinicId,
                    is_active: 1
                },
                relations: [
                    { module: "insurance_masters" },
                    { module: "health_insurance_carrier_master" }
                ]
            });

            // Group plans by carrier
            const carriersMap = new Map();

            if (insuranceResponse.code === 1 && insuranceResponse.data) {
                insuranceResponse.data.forEach(item => {
                    const carrier = item.health_insurance_carrier_master;
                    if (carrier) {
                        if (!carriersMap.has(carrier.id)) {
                            carriersMap.set(carrier.id, {
                                id: carrier.id,
                                name: carrier.health_insurance_carrier_name,
                                plans: []
                            });
                        }

                        // Add plan to carrier
                        if (item.insurance_masters) {
                            carriersMap.get(carrier.id).plans.push({
                                id: item.id,
                                name: item.insurance_masters.insurance_name,
                                cms_plan_id: item.insurance_masters.cms_plan_id
                            });
                        }
                    }
                });
            }

            setLoading(false);
            setOptions({
                insuranceType: Array.from(carriersMap.values()).map(carrier => ({
                    id: carrier.id,
                    name: carrier.name,
                    plans: carrier.plans
                })),
                appointmentType: appointmentResponse.data.appointmentType.map((at) => ({
                    id: at.id,
                    name: at.name,
                })),
            });
        } catch (error) {
            setLoading(false);
            console.error("Error fetching options data:", error);
        }
    };

    const handleLocationChange = (event) => {
        const locationId = event.target.value;
        const selectedLoc = locations.find(
            (loc) => loc.id.toString() === locationId.toString()
        );

        if (selectedLoc) {
            console.log('selectedLoc', selectedLoc);
            const formattedCity = selectedLoc.city.toLowerCase().replace(/\s+/g, "-");

            const streetNumber = selectedLoc.street.split(' ')[0]; // Gets "1515" from "1515 E BROAD ST"
            const formattedStreet = streetNumber.toLowerCase().replace(/\s+/g, "-");

            //   const formattedStreet = selectedLoc.street
            //     .toLowerCase()
            //     .replace(/\s+/g, "-");
            navigate(
                `/${clinicName}/bookAppoinment/${formattedCity}-${formattedStreet}`,
                { replace: true }
            );
            // navigate(
            //     `/bookAppoinment/${clinicName}/${formattedCity}-${formattedStreet}`,
            //     { replace: true }
            // );
            //  navigate(
            //         `/bookAppoinment/${clinicName}/${formattedCity}`,
            //         { replace: true }
            //       );
            setStreetId(selectedLoc.id);
            setCityName(selectedLoc.city);
            setStreetname(selectedLoc.street);

            setSelectedOptions({
                insuranceType: "",
                appointmentType: "",
                chooseCarrierAndPlan: "",
            });
            setSelectedOptionsId({
                insuranceTypeId: "",
                appointmentTypeId: "",
                chooseCarrierAndPlanId: "",
            });
            setInsurancePlans([]);
            setHasNoInsurance(false);
        }
    };

    const handleDropdownChange = async (category, key) => {
        const stringifyKey = key.target.value;
        let selectedOption;
        if (category === "chooseCarrierAndPlan") {
            selectedOption = insurancePlans.find(
                (opt) => opt.id.toString() === stringifyKey.toString()
            );
        } else {
            selectedOption = options[category].find(
                (opt) => opt.id.toString() === stringifyKey.toString()
            );
        }
        if (selectedOption) {
            setSelectedOptions({
                ...selectedOptions,
                [category]: selectedOption.name,
            });
            setSelectedOptionsId({
                ...selectedOptionsId,
                [`${category}Id`]: selectedOption.id,
            });

            if (category === "insuranceType") {
                const plans = await fetchInsurancePlans(selectedOption.id);
                setInsurancePlans(plans);
                setSelectedOptionsId((prev) => ({
                    ...prev,
                    chooseCarrierAndPlanId: "",
                }));
            }
        }
    };

    const fetchInsurancePlans = async (insuranceId) => {
        try {
            const response = await postData("masters/getMasterList", {
                modelName: "clinic_insurances",
                whereCondition: {
                    clinic_id: clinicId,
                    health_insurance_carrier_id: insuranceId,
                },
                relations: [{ module: "insurance_masters" }],
            });

            return response.data.map((plan) => ({
                id: plan.id,
                name: plan.insurance_masters.insurance_name,
            }));
        } catch (error) {
            console.error("Error fetching insurance plans:", error);
            return [];
        }
    };

    const handleInsuranceDropdownChange = async (key) => {
        const stringifyKey = key.target.value;

        if (stringifyKey === "noInsurance") {
            setHasNoInsurance(true);
            setSelectedOptionsId({
                ...selectedOptionsId,
                insuranceTypeId: "noInsurance",
                chooseCarrierAndPlanId: "noInsurance",
            });
            setSelectedOptions({
                ...selectedOptions,
                insuranceType: "I don't have insurance",
                chooseCarrierAndPlan: "",
            });
            setInsurancePlans([]);
        } else if (stringifyKey === "other") {
            setHasNoInsurance(false);
            setSelectedOptionsId({
                ...selectedOptionsId,
                insuranceTypeId: "other",
                chooseCarrierAndPlanId: "other",
            });
            setSelectedOptions({
                ...selectedOptions,
                insuranceType: "Other",
                chooseCarrierAndPlan: "",
            });
            setInsurancePlans([]);
        } else {
            setHasNoInsurance(false);

            // Find selected carrier
            const selectedCarrier = options.insuranceType.find(
                (opt) => opt.id.toString() === stringifyKey.toString()
            );

            if (selectedCarrier) {
                setSelectedOptions({
                    ...selectedOptions,
                    insuranceType: selectedCarrier.name,
                    chooseCarrierAndPlan: "",
                });
                setSelectedOptionsId({
                    ...selectedOptionsId,
                    insuranceTypeId: selectedCarrier.id,
                    chooseCarrierAndPlanId: "",
                });

                // Set plans for this carrier
                setInsurancePlans(selectedCarrier.plans || []);
            }
        }
    };


    const handleSaveAndNavigate = () => {
        const { appointmentTypeId, insuranceTypeId } = selectedOptionsId;

        const patientTypeIdPlaceholder = "existingPatient";
        const planId = insuranceTypeId || "noInsurance";

        const formattedCity = cityname.toLowerCase().replace(/\s+/g, "-");
        //const formattedStreet = streetName.toLowerCase().replace(/\s+/g, "-");

        const streetNumber = streetName.split(' ')[0]; // Gets "1515" from "1515 E BROAD ST"
        const formattedStreet = streetNumber.toLowerCase().replace(/\s+/g, "-");

        const encryptedAppointmentTypeId = encrypt(appointmentTypeId.toString());
        const urlSafeAppointmentTypeId = encodeURIComponent(
            encryptedAppointmentTypeId
        );

        // Debug logs
        console.log("selectedOptionsId:", selectedOptionsId);
        console.log("appointmentTypeId:", appointmentTypeId);
        console.log("chooseCarrierAndPlanId:", planId);
        console.log("cityname:", cityname);
        console.log("formattedCity:", formattedCity);
        console.log("streetName:", streetName);
        console.log("formattedStreet:", formattedStreet);
        console.log("encryptedAppointmentTypeId:", encryptedAppointmentTypeId);
        console.log("urlSafeAppointmentTypeId:", urlSafeAppointmentTypeId);
        console.log("clinicName:", clinicName);

        localStorage.removeItem("selectedSlot");
        localStorage.removeItem("selectedDoctor");
        localStorage.removeItem("selectedDate");
        localStorage.removeItem("selectedAppointment");

        //const url = `/clinicaddbookingdetails/${clinicName}/${formattedCity}-${formattedStreet}/${planId}/${urlSafeAppointmentTypeId}`;
        const url = `/${clinicName}/clinicaddbookingdetails/${formattedCity}-${formattedStreet}/${planId}/${urlSafeAppointmentTypeId}`;
        console.log("Navigating to URL:", url);

        navigate(url);
    };

    return (
        <>
            {loading && <Loader2 />}
            <>
                <ClinicBookingHeader
                    clinicName={clinicNameData}
                    logoImg={logoImg}
                    locations={locations}
                    selectedLocationId={streetid}
                    onLocationChange={handleLocationChange}
                />

                <AppointmentForm
                    selectedOptions={selectedOptions}
                    selectedOptionsId={selectedOptionsId}
                    setSelectedOptions={setSelectedOptions}
                    setSelectedOptionsId={setSelectedOptionsId}
                    handleDropdownChange={handleDropdownChange}
                    handleSaveAndNavigate={handleSaveAndNavigate}
                    handleInsuranceDropdownChange={handleInsuranceDropdownChange}
                    hasNoInsurance={hasNoInsurance}
                    options={options}
                    insurancePlans={insurancePlans}
                    locations={locations}
                    selectedLocationId={streetid}
                    onLocationChange={handleLocationChange}
                />
                <ClinicBookingFooter />
            </>
        </>
    );
}

function AppointmentForm({
    selectedOptions,
    selectedOptionsId,
    setSelectedOptions,
    setSelectedOptionsId,
    handleDropdownChange,
    handleSaveAndNavigate,
    handleInsuranceDropdownChange,
    hasNoInsurance,
    options,
    insurancePlans,
    locations,
    selectedLocationId,
    onLocationChange,
}) {
    const handleButtonClick = (category, optionName) => {
        const selectedOption = options[category].find(
            (opt) => opt.name === optionName
        );
        if (selectedOption) {
            setSelectedOptions({ ...selectedOptions, [category]: selectedOption.name });
            setSelectedOptionsId((prev) => ({
                ...prev,
                [`${category}Id`]: selectedOption.id,
            }));
        }
    };

    return (
        <section className="w-full min-h-mh480 mt-8">
            <div className="container mx-auto px-4">
                <div className="bg-grayColor rounded-lg p-8 shadow-md">
                    <div className="w-full md:w-1/2 mb-6">
                        <label className="font-fontPoppins text-lg font-semibold text-gray-700 mb-2 block">
                            Choose Your Location <CheckIcon />
                        </label>
                        <CustomSelect
                            value={selectedLocationId}
                            onChange={onLocationChange}
                            options={locations.map((loc) => ({
                                value: loc.id,
                                label: `${loc.street}, ${loc.city}, ${loc.state} ${loc.zipcode}`,
                            }))}
                            placeholder="Select a Location"
                        />
                    </div>

                    {/* Insurance Section */}
                    <div className="w-full mb-6">
                        <label className="font-fontPoppins text-lg font-semibold text-gray-700 mb-2 block">
                            Choose Your Insurance{" "}
                            {selectedOptionsId.insuranceTypeId ? <CheckIcon /> : null}
                        </label>

                        <div className="md:w-1/2">
                            <CustomSelect
                                value={selectedOptionsId.insuranceTypeId}
                                onChange={handleInsuranceDropdownChange}
                                options={[
                                    ...options.insuranceType.map((option) => ({
                                        value: option.id,
                                        label: option.name,
                                    })),
                                    {
                                        value: "other",
                                        label: "Other",
                                    },
                                    {
                                        value: "noInsurance",
                                        label: "No Insurance",
                                    }
                                ]}
                                placeholder="Select Your Insurance Carrier"
                            />
                        </div>

                        {/* Display selected insurance carrier */}
                        {/* {selectedOptions.insuranceType && (
                            <div className="md:w-1/2 mt-3">
                                <div className="font-fontPoppins text-sm font-semibold text-gray-800">
                                    Selected Carrier: {selectedOptions.insuranceType}
                                </div>
                            </div>
                        )} */}

                        {/* Insurance Plan Dropdown - Only show if carrier selected and has plans */}
                        {/* {insurancePlans.length > 0 && !hasNoInsurance && selectedOptionsId.insuranceTypeId !== "other" && (
                            <div className="md:w-1/2 mt-4">
                                <label className="font-fontPoppins text-sm font-semibold text-gray-700 mb-2 block">
                                    Select Your Plan{" "}
                                    {selectedOptionsId.chooseCarrierAndPlanId ? <CheckIcon /> : null}
                                </label>
                                <CustomSelect
                                    value={selectedOptionsId.chooseCarrierAndPlanId}
                                    onChange={(e) => handleDropdownChange("chooseCarrierAndPlan", e)}
                                    options={insurancePlans.map((plan) => ({
                                        value: plan.id,
                                        label: plan.name,
                                    }))}
                                    placeholder="Select Your Insurance Plan"
                                />
                            </div>
                        )} */}
                    </div>


                    {/* Appointment Type Section */}
                    <div className="w-full mb-6">
                        <label className="font-fontPoppins text-lg font-semibold text-gray-700 mb-2 block">
                            Appointment Type{" "}
                            {selectedOptions.appointmentType ? <CheckIcon /> : null}
                        </label>
                        <div className="md:w-1/2">
                            <CustomSelect
                                value={selectedOptionsId.appointmentTypeId}
                                onChange={(e) => handleDropdownChange("appointmentType", e)}
                                options={options.appointmentType.map((option) => ({
                                    value: option.id,
                                    label: option.name,
                                }))}
                                placeholder="Select Appointment Type"
                            />
                        </div>
                    </div>

                </div>
            </div>
            <div className="container mx-auto px-4 mt-6 text-center">
                {selectedLocationId &&
                    selectedOptionsId.appointmentTypeId &&
                    (selectedOptionsId.insuranceTypeId || hasNoInsurance) ? (
                    <BtnBlue handleSave={handleSaveAndNavigate} />
                ) : (
                    <BtnGray />
                )}
            </div>
        </section>
    );
}

function CheckIcon() {
    return (
        <span>
            <i className="fa-solid fa-check-circle text-sky-400"></i>
        </span>
    );
}

function BtnGray() {
    return (
        <button className="w-56 h-10 font-fontPoppins font-bold bg-gray-300 text-base rounded-full text-gray-600 font-semibold hover:cursor-not-allowed">
            Choose Appointment <i className="fa-solid fa-arrow-right-long"></i>
        </button>
    );
}

function BtnBlue({ handleSave }) {
    return (
        <button
            onClick={handleSave}
            className="w-56 h-10 font-fontPoppins font-bold bg-blueColor text-base rounded-full text-white font-semibold hover:opacity-85"
        >
            Choose Appointment <i className="fa-solid fa-arrow-right-long"></i>
        </button>
    );
}

export default CliniBookAnAppoinment;